// extracted by mini-css-extract-plugin
export default {"errorBoundaryLayoutContainer":"style_errorBoundaryLayoutContainer__Sp3ab","content":"style_content__JRQno","msg":"style_msg__R-IFf","pic":"style_pic__c1xXf"};